export const menuDataEn = {
  indiskaForratter: [
    {
      number: "1",
      name: "Papadam",
      description: "2 pcs. crispy lentil breads. Served with mango chutney.",
      price: "55",
      allergens: "Medium chili"
    },
    {
      number: "2",
      name: "Vegetable Samosa",
      description: "2 pcs. Indian vegetable pastries. Served with salad and mint sauce.",
      price: "69",
      allergens: "Gluten, Dairy products, Medium chili"
    },
    {
      number: "3",
      name: "Onion Bhaji",
      description: "Well-seasoned fried onion. Served with mint sauce.",
      price: "69",
      allergens: "Medium chili"
    },
    {
      number: "4",
      name: "Indian Spring Rolls",
      description: "3 pcs. spring rolls filled with spiced chicken mince. Served deep-fried with mint sauce.",
      price: "79",
      allergens: "Gluten, Dairy products, Medium chili"
    },
    {
      number: "5",
      name: "Chicken Seekh Kebab",
      description: "2 pcs. fried chicken kebab. Served with salad and imli chutney.",
      price: "99",
      allergens: "Gluten, Dairy products, Medium chili"
    },
    {
      number: "100",
      name: "Chicken Kathi Roll",
      description: "Grilled chicken rolled in paratha with salad and sauce. Served with hari chutney.",
      price: "89",
      allergens: "Gluten, Dairy products, Medium chili"
    },
    {
      number: "102",
      name: "Pani Puri",
      description: "6 pcs. small, crispy balls (puris) filled with a spicy mixture of potatoes, chickpeas and various spices. Served with tamarind, mint and coriander water.",
      price: "75",
      allergens: "Gluten, Dairy products, Medium chili"
    },
    {
      number: "104",
      name: "Mix Fusion Thali",
      description: "1 pc. chicken roll, 2 pcs. samosa, 2 pcs. seekh kebab. Served with imli chutney, mint sauce and salad.",
      price: "199",
      allergens: "Gluten, Dairy products, Medium chili"
    }
  ],
  kockensRekommendation: [
    {
      number: "6",
      name: "Chicken Tikka Masala",
      description: "Chicken grilled and cooked with yogurt, Indian spices, almond, coconut and cream. Cannot be served without nuts.",
      price: "159",
      allergens: "Nuts, Dairy products, Mild chili"
    },
    {
      number: "7",
      name: "Hot Chili Chicken",
      description: "Grilled chicken with chili, onion, bell pepper, masala sauce, sugar and sweet chili sauce.",
      price: "169",
      allergens: "Dairy products, Strong chili"
    },
    {
      number: "8",
      name: "Garlic Chicken Tikka Masala",
      description: "Garlic-marinated chicken cooked with yogurt, Indian spices, almond, coconut and cream. Cannot be served without nuts.",
      price: "169",
      allergens: "Nuts, Dairy products, Mild chili"
    },
    {
      number: "9",
      name: "Korma",
      description: "Cooked in a sauce with cream, black pepper, coconut and almond.",
      variants: "Chicken 169kr | Beef 179kr | Lamb 199kr | Prawns 199kr",
      price: "169",
      allergens: "Nuts, Dairy products, Mild chili"
    },
    {
      number: "10",
      name: "Tandoori Chicken Moglai Rezala",
      description: "Grilled chicken with onion, cream and fresh spices.",
      price: "169",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "11",
      name: "Bhuna",
      description: "Casserole cooked with onion, tomato, bell pepper.",
      variants: "Chicken 169kr | Beef 179kr | Lamb 199kr",
      price: "169",
      allergens: "Medium chili"
    },
    {
      number: "12",
      name: "Jalfrezi",
      description: "Spicy casserole with onion, tomato, bell pepper and fresh chili.",
      variants: "Chicken 169kr | Beef 179kr | Lamb 199kr",
      price: "169",
      allergens: "Strong chili"
    },
    {
      number: "13",
      name: "Madras",
      description: "South Indian dish with spicy Madras sauce and lemon.",
      variants: "Chicken 169kr | Beef 179kr | Lamb 199kr",
      price: "169",
      allergens: "Strong chili"
    },
    {
      number: "14",
      name: "Vindaloo",
      description: "Dish with potatoes cooked in an extra hot vindaloo sauce.",
      variants: "Chicken 169kr | Beef 179kr | Lamb 199kr",
      price: "169",
      allergens: "Extra strong chili"
    },
    {
      number: "15",
      name: "Karai",
      description: "Casserole cooked with tomatoes, onion, bell pepper and spices.",
      variants: "Chicken 169kr | Lamb 199kr | Prawns 199kr",
      price: "169",
      allergens: "Mild chili"
    },
    {
      number: "16",
      name: "Saagwala",
      description: "Cooked with spinach, cream, ginger, garlic, onion and bell pepper.",
      variants: "Chicken 169kr | Beef 179kr | Lamb 199kr",
      price: "169",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "17",
      name: "Bombay Masala",
      description: "Cooked with traditional sauce, onion, bell pepper, tamarind and fruit.",
      variants: "Chicken 169kr | Prawns 199kr",
      price: "169",
      allergens: "Nuts, Dairy products, Medium chili"
    },
    {
      number: "18",
      name: "Butter Chicken Tikka",
      description: "Grilled chicken cooked in a rich and creamy tomato sauce, ginger, green chili, cream and cashews and sauce with butter. Cannot be served without cashew and chili.",
      price: "169",
      allergens: "Nuts, Dairy products, Medium chili"
    },
    {
      number: "19",
      name: "Lamb Rogan Josh",
      description: "Lamb with tomato, onion, bell pepper, ginger and chef's sauce.",
      price: "199",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "66",
      name: "Shahi Qorma (Authentic dish)",
      description: "Chicken (with bone) cooked in creamy sauce with tomato, cream, and a blend of aromatic spices. Served with naan bread.",
      price: "199",
      allergens: "Dairy products, Strong chili"
    },
    {
      number: "67",
      name: "Biryani (Authentic dish)",
      description: "Spiced rice cooked with tomato sauce, yogurt, bell pepper and onion. Served with raita.",
      variants: "Vegetables 169kr | Prawns 179kr | Chicken thigh 199kr",
      price: "169",
      allergens: "Dairy products, Strong chili"
    },
    {
      number: "121",
      name: "Achari Handi",
      description: "Cooked with our own pickles, yogurt, traditional sauce, spices and coriander.",
      variants: "Chicken 169kr | Beef 179kr | Lamb 199kr",
      price: "169",
      allergens: "Dairy products, Strong chili"
    }
  ],
  balti: [
    {
      number: "20",
      name: "King Prawn",
      description: "Large prawns in balti sauce with garlic, onion, bell pepper, fresh coriander, almond and tomato.",
      price: "179",
      allergens: "Nuts, Dairy products, Medium chili"
    },
    {
      number: "21",
      name: "Chicken Tikka",
      description: "Grilled chicken in balti sauce with garlic, onion, bell pepper, fresh coriander, almond and tomato.",
      price: "179",
      allergens: "Nuts, Dairy products, Medium chili"
    },
    {
      number: "22",
      name: "Chicken Tikka Garlic Balti",
      description: "Garlic-marinated grilled chicken in balti sauce with garlic, onion, bell pepper, fresh coriander, almond and tomato.",
      price: "179",
      allergens: "Nuts, Dairy products, Medium chili"
    }
  ],
  tandooriGrillat: [
    {
      number: "23",
      name: "Tandoori Chicken Sizzler",
      description: "Marinated chicken thigh grilled in tandoor oven.",
      price: "179",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "24",
      name: "Chicken Tikka Sizzler",
      description: "Marinated chicken fillet pieces grilled in tandoor oven.",
      price: "189",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "25",
      name: "Garlic Chicken Tikka Sizzler",
      description: "Garlic-marinated chicken fillet pieces grilled in tandoor oven.",
      price: "189",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "26",
      name: "Mix Sizzler",
      description: "Marinated and grilled chicken fillet, garlic chicken fillet and giant prawns.",
      price: "219",
      allergens: "Dairy products, Medium chili"
    }
  ],
  vegetariskt: [
    {
      number: "28",
      name: "Paneer Mango Masala",
      description: "Halloumi cheese cooked with mango, almond, coconut, cream and mild sauce. Cannot be served without nuts.",
      price: "169",
      allergens: "Nuts, Dairy products, Mild chili"
    },
    {
      number: "29",
      name: "Mix Vegetable Curry",
      description: "Seasonal vegetables cooked with medium curry sauce and tomato sauce.",
      price: "179",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "30",
      name: "Tarka Daal",
      description: "Fried lentils cooked with tomato, garlic, butter and coriander.",
      price: "179",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "31",
      name: "Palak Paneer",
      description: "Spinach leaves and Halloumi cheese cooked with garlic, onion, and bell pepper.",
      price: "169",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "131",
      name: "Chana Saag",
      description: "Indian chickpeas cooked with spinach, tomato, onion, coriander and Indian curry.",
      price: "159",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "132",
      name: "Paneer Tikka Karai",
      description: "Fresh cheese cooked with tomato, onion, bell pepper and Indian curry.",
      price: "169",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "133",
      name: "Chana Masala",
      description: "Chickpeas cooked in a spicy sauce with ingredients such as tomato, onion, garlic, ginger and various spices like garam masala, cumin and coriander.",
      price: "159",
      allergens: "Dairy products, Medium chili"
    },
    {
      number: "137",
      name: "Tofu Dopiaza",
      description: "Casserole cooked with tomatoes and spices.",
      price: "169",
      allergens: "Dairy products, Medium chili"
    }
  ],
  naan: [
    {
      number: "32",
      name: "Paratha",
      description: "Indian bread fried in butter, with a crispy surface and soft inside.",
      price: "35",
      allergens: "Gluten, Dairy products"
    },
    {
      number: "33",
      name: "Plain Naan",
      description: "A soft and airy Indian flatbread served with butter.",
      price: "35",
      allergens: "Gluten, Dairy products"
    },
    {
      number: "34",
      name: "Garlic Naan",
      description: "A flavorful variant of traditional Indian naan seasoned with garlic and butter for an extra taste experience.",
      price: "40",
      allergens: "Gluten, Dairy products"
    },
    {
      number: "35",
      name: "Moglai Naan",
      description: "A luxurious variant of traditional Indian naan bread, filled with almond, coconut, sugar and butter.",
      price: "40",
      allergens: "Dairy products, Nuts, Gluten"
    },
    {
      number: "36",
      name: "Paneer Naan",
      description: "An Indian bread filled with crumbled cheese.",
      price: "40",
      allergens: "Gluten, Dairy products"
    },
    {
      number: "141",
      name: "Masala Naan",
      description: "A flavorful variant of traditional Indian naan bread, seasoned with garlic, onion and coriander for an extra taste experience.",
      price: "45",
      allergens: "Gluten, Dairy products"
    },
    {
      number: "142",
      name: "Tandoori Roti",
      description: "Tandoori roti is an Indian flatbread that is baked in a tandoor.",
      price: "19",
      allergens: "Dairy products, Gluten"
    }
  ],
  indiskaTillbehor: [
    {
      number: "37",
      name: "Raita",
      description: "Raita yogurt containing spices, sugar, cucumber, and tomato.",
      price: "30",
      allergens: "Dairy products"
    },
    {
      number: "38",
      name: "Pickles",
      description: "Pickled vegetables or fruits preserved in vinegar, salt, sugar and spices.",
      price: "25",
      allergens: "Strong chili"
    },
    {
      number: "39",
      name: "Mango Chutney",
      description: "An Indian sauce made from ripe mango fruits, sugar, vinegar and spices.",
      price: "25",
      allergens: "Mild chili"
    },
    {
      number: "40",
      name: "Mint Sauce",
      description: "A fresh sauce made from fresh mint, vinegar, sugar and yogurt.",
      price: "25",
      allergens: "Dairy products"
    },
    {
      number: "41",
      name: "Natural Yogurt",
      description: "Creamy and unsweetened yogurt made from fermented milk.",
      price: "20",
      allergens: "Dairy products"
    },
    {
      number: "42",
      name: "Extra Rice",
      description: "Small 29kr | Large 49kr",
      price: "29",
      allergens: ""
    }
  ],
  thaiForratter: [
    {
      number: "1",
      name: "Vegetable Spring Rolls",
      description: "10 pcs. spring rolls filled with a mix of lovely vegetables. Served with salad and a tasty sweet chili dipping sauce.",
      price: "89",
      allergens: "Gluten"
    },
    {
      number: "2",
      name: "Beef Spring Rolls",
      description: "2 pcs. spring rolls filled with juicy beef and flavorful ingredients. Served with salad and sweet chili dipping sauce.",
      price: "99",
      allergens: "Gluten"
    },
    {
      number: "3",
      name: "Crispy Prawns",
      description: "8 - 10 pcs. deep-fried prawns. Served with salad and sweet chili dipping sauce.",
      price: "129",
      allergens: "Gluten"
    },
    {
      number: "4",
      name: "Mixed Fried Platter",
      description: "Contains 4 pcs. vegetarian spring rolls, 1 pc. minced meat filled spring roll, 4 pcs. deep-fried prawns, salad and 2 sauces.",
      price: "139",
      allergens: "Gluten"
    },
    {
      number: "5",
      name: "Crispy Chicken",
      description: "4 - 5 pcs. chicken fillet, marinated and breaded in panko. Served lightly fried with sweet and sour sauce and salad.",
      price: "129",
      allergens: "Gluten"
    },
    {
      number: "6",
      name: "Chicken Satay Skewers",
      description: "4 pcs. authentic Thai chicken skewers with delicious homemade peanut sauce. Served deep-fried with salad.",
      price: "139",
      allergens: "Gluten, Medium chili, Nuts"
    }
  ],
  thaiHuvratter: [
    {
      number: "21",
      name: "Curry Fusion",
      description: "Cooked with house spicy panang sauce together with coconut milk, vegetables and spices.",
      variants: "Chicken 139kr | Beef 149kr | Prawns 159kr",
      price: "139",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "22",
      name: "Cashew Wok",
      description: "Cooked with cashews and vegetables in a flavorful wok sauce.",
      variants: "Chicken 139kr | Beef 149kr | Prawns 159kr",
      price: "139",
      allergens: "Gluten, Nuts, Medium chili"
    },
    {
      number: "23",
      name: "Summer Wok",
      description: "Woked together with garlic, egg, spices, vegetables, wok sauce and egg noodles.",
      variants: "Chicken 139kr | Beef 149kr | Prawns 159kr",
      price: "139",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "24",
      name: "Lime Wok",
      description: "Woked together with garlic, egg, lime, spices, vegetables and rice noodles (wide).",
      variants: "Chicken 139kr | Beef 149kr | Prawns 159kr",
      price: "139",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "25",
      name: "Rice Noodle Wok",
      description: "Woked together with egg, garlic, tamarind sauce, spices, vegetables, rice noodles, peanuts and bean sprouts.",
      variants: "Chicken 139kr | Beef 149kr | Prawns 159kr",
      price: "139",
      allergens: "Gluten, Nuts, Medium chili"
    },
    {
      number: "26",
      name: "Fried Rice",
      description: "Classic dish fried with rice, garlic, egg and vegetables.",
      variants: "Chicken 139kr | Beef 149kr | Prawns 159kr",
      price: "139",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "27",
      name: "Pineapple Fried Rice",
      description: "Classic dish fried with pineapple, rice, garlic, egg and vegetables.",
      variants: "Chicken 149kr | Beef 159kr | Prawns 169kr",
      price: "149",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "28",
      name: "Green Curry",
      description: "Cooked with house spicy green sauce together with coconut milk, vegetables and spices.",
      variants: "Chicken 149kr | Beef 159kr | Prawns 169kr",
      price: "149",
      allergens: "Gluten, Medium chili"
    },
    {
      number: "29",
      name: "Crispy Duck Breast",
      description: "Deep-fried duck breast. Served with garlic and vegetables.",
      price: "169",
      allergens: "Gluten, Medium chili"
    }
  ],
  sushiHosomaki: [
    {
      number: "1",
      name: "Avocado",
      description: "Rice and avocado, elegantly wrapped in seaweed.",
      price: "79",
      allergens: ""
    },
    {
      number: "2",
      name: "Cucumber",
      description: "Rice and cucumber, elegantly wrapped in seaweed.",
      price: "79",
      allergens: ""
    },
    {
      number: "3",
      name: "Salmon",
      description: "Rice and salmon, elegantly wrapped in seaweed.",
      price: "89",
      allergens: ""
    },
    {
      number: "4",
      name: "Tuna",
      description: "Rice and tuna, elegantly wrapped in seaweed.",
      price: "89",
      allergens: ""
    }
  ],
  sushiUramaki: [
    {
      number: "5",
      name: "California Roll",
      description: "Imitation crab, avocado and cucumber.",
      price: "99",
      allergens: ""
    },
    {
      number: "6",
      name: "Spicy Tuna Roll",
      description: "Tuna mixed with spicy mayo and spring onion.",
      price: "109",
      allergens: "Spicy"
    },
    {
      number: "7",
      name: "Philadelphia Roll",
      description: "Salmon, cream cheese and cucumber.",
      price: "109",
      allergens: "Dairy products"
    },
    {
      number: "8",
      name: "Dragon Roll",
      description: "Shrimp tempura, cucumber topped with avocado and unagi sauce.",
      price: "119",
      allergens: "Gluten"
    }
  ],
  sushiNigiri: [
    {
      number: "9",
      name: "Salmon",
      description: "Rice topped with fresh salmon.",
      price: "49",
      allergens: ""
    },
    {
      number: "10",
      name: "Tuna",
      description: "Rice topped with fresh tuna.",
      price: "49",
      allergens: ""
    },
    {
      number: "11",
      name: "Shrimp",
      description: "Rice topped with cooked shrimp.",
      price: "45",
      allergens: ""
    },
    {
      number: "12",
      name: "Eel",
      description: "Rice topped with grilled eel and unagi sauce.",
      price: "55",
      allergens: ""
    }
  ],
  thaiTillbehor: [
    { name: "Rice", price: "25", allergens: "" },
    { name: "Cashew Nuts", price: "15", allergens: "Nuts" },
    { name: "Sweet Chili Sauce", price: "15", allergens: "" },
    { name: "Sweet and Sour Sauce", price: "15", allergens: "" },
    { name: "Peanuts", price: "15", allergens: "Nuts" },
    { name: "Peanut Sauce", price: "20", allergens: "Nuts" },
    { name: "Spicy Sauce", price: "15", allergens: "Spicy" },
    { name: "Prawn Crackers", price: "20", allergens: "Gluten" }
  ],
  sushiTillbehor: [
    { name: "Wakame", price: "25", allergens: "" },
    { name: "Unagi Sauce", price: "15", allergens: "" },
    { name: "Chili Mayo", price: "15", allergens: "Spicy" },
    { name: "Soy Sauce", price: "10", allergens: "Gluten" },
    { name: "Ginger", price: "10", allergens: "" },
    { name: "Wasabi", price: "10", allergens: "Spicy" }
  ],
  barnmeny: [
    {
      number: "150",
      name: "Kids Chicken Nuggets",
      description: "Crispy chicken nuggets served with fries and ketchup.",
      price: "89",
      allergens: "Gluten"
    },
    {
      number: "151",
      name: "Kids Pasta",
      description: "Pasta with tomato sauce or cream sauce.",
      price: "79",
      allergens: "Gluten, Dairy products"
    },
    {
      number: "152",
      name: "Kids Fried Rice",
      description: "Mild fried rice with chicken and vegetables.",
      price: "79",
      allergens: "Gluten"
    }
  ]
};
